export const Constants = {
  TAG_NAME: 'pop-pc-table-header-component',
  DATA_SORT_BY_ATTRIBUTE: 'data-sort-by',
  DATA_TABLE_TYPE_ATTRIBUTE: 'data-table-type',
  PERFORMANCE_COLUMN_IDS: {
    PRODUCT_NAME: 'product-name',
  },
  PERFORMANCE_ROW_HEADERS: {
    PRODUCT_NAME: 'Product Name',
  },
  CHEVRON_CUSTOM_CLASS: 'custom-chevron-down',
} as const;
